<script setup lang="ts">
import { CSSProperties, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { CloseOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons-vue'
import fileUploadPinia from '@/store/fileUpload'
import wkUploadCell from './wk-upload-cell.vue'
import { CommonType } from '@/interface'

const { lists } = storeToRefs(fileUploadPinia())

const style = ref<CSSProperties>({
  fontSize: '16px',
  fontWeight: 'bold'
})

const visible = ref<boolean>(false)

const isUnfold = ref<boolean>(false)
const unfoldClick = () => {
  isUnfold.value = !isUnfold.value
}
const close = () => {
  visible.value = false
}

// const upload = () => {
//   console.log('上传')
// }
/**
 * 上传完成
 */
const uploadCompleted = (index: number, res: CommonType) => {
  const data = lists.value[index]
  data.res = res
  data.complete = true
  if (data.resolve) {
    data.resolve(data)
  }
}

const uploadDelete = (index: number) => {
  lists.value.splice(index, 1)
}

const cancelTokenChange = (cancelToken: unknown, index: number) => {
  const data = lists.value[index]
  // this.$set(data, 'cancelToken', cancelToken)
  data.cancelToken = cancelToken
}
</script>

<template>
  <transition name="fade">
    <div v-if="visible" class="file-upload">
      <div class="file-upload__header display-flex items-center">
        <div class="title">附件上传</div>
        <div>
          <a-button type="text" class="unfold-button" @click="unfoldClick">
            <template #icon>
              <minus-outlined v-show="isUnfold" :style="style" />
              <plus-outlined v-show="!isUnfold" :style="style" />
            </template>
          </a-button>
          <a-button type="text" @click="close">
            <template #icon><close-outlined /></template>
          </a-button>
        </div>
      </div>
      <div v-show="isUnfold" class="file-upload__body">
        <wk-upload-cell
          v-for="(item, index) in lists"
          :key="index"
          :index="index"
          :file="item.file"
          :request="item.request"
          :params="item.params"
          :complete="item.complete"
          @completed="uploadCompleted"
          @delete="uploadDelete"
          @cancelTokenChange="cancelTokenChange"
        />
      </div>
    </div>
  </transition>
</template>

<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  // will-change: transform;
  transition: all 350ms ease;
}

.fade-enter-from {
  transform: translateY(0);
}

.fade-leave-to {
  transform: translateY(100%);
}

.file-upload {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 1000000;
  width: 380px;
  font-size: 14px;
  background-color: white;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);

  &__header {
    padding: 5px 15px;
    height: 40px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);

    .title {
      flex: 1;
      font-weight: bold;
    }

    .ant-button {
      padding: 6px;
      margin-left: 0;
      background: transparent;
      border: none;
      outline: none;
      font-weight: bold;

      // :deep(.anticon) {
      //   font-size: 13px;
      //   font-weight: bold;
      // }
    }
  }

  &__body {
    overflow-y: auto;
    padding: 10px;
    height: 350px;

    .wk-upload-cell + .wk-upload-cell {
      margin-top: 10px;
    }
  }
}
</style>
